import {Injectable} from '@angular/core';
import {PagingResolverService} from '@abstract/paging-resolver.service';
import {EquipmentPagesService} from './equipment-pages.service';
import {Router} from '@angular/router';

@Injectable()
export class EquipmentPagesResolverService extends PagingResolverService {
    constructor(
        service: EquipmentPagesService,
        router: Router,
    ) {
        super(service, router);
    }
}
